import { createContext, useContext, useState } from 'react';

export const LanguageContext = createContext();

export const LanguageProvider = ({ children }) => {
    // const [language, setLanguage] = useState('heb');
    // const [direction, setDirection] = useState('rtl');
    const [language, setLanguage] = useState('en');
    const [direction, setDirection] = useState('ltr');

    return (
        <LanguageContext.Provider value={{ language, setLanguage, direction, setDirection }}>
            <div dir={direction}>
                {children}
            </div>
        </LanguageContext.Provider>
    );
};

export const useLanguage = () => {
    return useContext(LanguageContext);
};
